/**************************************************
 * Nombre:       Formulario_Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import Tarjetas_Producto from "../Tarjetas/Tarjetas_Producto";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {obtenerTotalProductos} from "../Utilidades/obtenerTotalProductos";

const Formulario_Lista_Productos = ({...props}) => {
    const [productos, setProductos] = useState([])


    useEffect(() => {


        setProductos(props.props.getValues('productos'))

    }, [props.props.watch('productos')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {productos.map((it, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Tarjetas_Producto item={it}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-start'} sx={{mt: -1}}>
                    <Typography sx={{
                        fontSize: 12,
                        fontWeight: 400
                    }}>{`*El valor total sera comprobado por un operario`}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'} sx={{mt: 1}}>
                    <Typography sx={{
                        fontSize: 20,
                        fontWeight: 600
                    }}>{`Valor Pedido: ${formatoMoneda(obtenerTotalProductos(productos))}`}</Typography>
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Lista_Productos